"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base64EnabledDto = exports.SelectOptionsDto = exports.PaginatedSearchDto = exports.IncludeAdditionalDataDto = exports.CronQueryParamsDto = exports.GenericResponseDto = exports.IdsQueryDto = exports.IdsOptionalDto = exports.IdsDto = exports.AuthenticatedRequestDto = exports.SimpleResourceDto = exports.IdAndNameDto = exports.IdDto = exports.PaginationSearchQuery = exports.SharedPaginatedResultDto = exports.PaginationResultDto = exports.PaginationMetaDto = exports.PaginationRangeQuery = exports.IData = exports.PaginationQuery = exports.HUNDRED_PERCENT = exports.MINIMUM_ALLOWED_PERCENTAGE = exports.MINIMUM_ALLOWED_PRICE = exports.DEFAULT_PAGE = exports.DEFAULT_MINIMUM_ITEMS_PER_PAGE = exports.DEFAULT_MAXIMUM_ITEMS_PER_PAGE = exports.FindOneParams = void 0;
class FindOneParams {
}
exports.FindOneParams = FindOneParams;
exports.DEFAULT_MAXIMUM_ITEMS_PER_PAGE = 100;
exports.DEFAULT_MINIMUM_ITEMS_PER_PAGE = 30;
exports.DEFAULT_PAGE = 1;
exports.MINIMUM_ALLOWED_PRICE = 0.5;
exports.MINIMUM_ALLOWED_PERCENTAGE = 0.01;
exports.HUNDRED_PERCENT = 100;
class PaginationQuery {
    constructor(query) {
        var _a, _b;
        this.itemsPerPage = exports.DEFAULT_MINIMUM_ITEMS_PER_PAGE;
        this.offset = query === null || query === void 0 ? void 0 : query.offset;
        this.itemsPerPage = Math.min((_a = query === null || query === void 0 ? void 0 : query.max) !== null && _a !== void 0 ? _a : exports.DEFAULT_MAXIMUM_ITEMS_PER_PAGE, (query === null || query === void 0 ? void 0 : query.itemsPerPage) || ((_b = query === null || query === void 0 ? void 0 : query.min) !== null && _b !== void 0 ? _b : exports.DEFAULT_MINIMUM_ITEMS_PER_PAGE));
        if (this.offset == undefined) {
            this.page = (query === null || query === void 0 ? void 0 : query.page) || exports.DEFAULT_PAGE;
        }
    }
}
exports.PaginationQuery = PaginationQuery;
class IData {
}
exports.IData = IData;
class PaginationRangeQuery {
    constructor() {
        this.startPage = 1;
        this.endPage = 1;
        this.itemsPerPage = 100;
    }
}
exports.PaginationRangeQuery = PaginationRangeQuery;
class PaginationMetaDto {
}
exports.PaginationMetaDto = PaginationMetaDto;
class PaginationResultDto {
    constructor(data, meta) {
        this.data = data;
        this.meta = meta;
    }
}
exports.PaginationResultDto = PaginationResultDto;
class SharedPaginatedResultDto extends PaginationResultDto {
}
exports.SharedPaginatedResultDto = SharedPaginatedResultDto;
class PaginationSearchQuery extends PaginationQuery {
}
exports.PaginationSearchQuery = PaginationSearchQuery;
class IdDto {
}
exports.IdDto = IdDto;
class IdAndNameDto extends IdDto {
}
exports.IdAndNameDto = IdAndNameDto;
class SimpleResourceDto extends IdAndNameDto {
}
exports.SimpleResourceDto = SimpleResourceDto;
class AuthenticatedRequestDto {
}
exports.AuthenticatedRequestDto = AuthenticatedRequestDto;
class IdsDto {
}
exports.IdsDto = IdsDto;
class IdsOptionalDto {
}
exports.IdsOptionalDto = IdsOptionalDto;
class IdsQueryDto {
}
exports.IdsQueryDto = IdsQueryDto;
class GenericResponseDto {
}
exports.GenericResponseDto = GenericResponseDto;
class CronQueryParamsDto {
}
exports.CronQueryParamsDto = CronQueryParamsDto;
class IncludeAdditionalDataDto {
}
exports.IncludeAdditionalDataDto = IncludeAdditionalDataDto;
class PaginatedSearchDto extends PaginationQuery {
}
exports.PaginatedSearchDto = PaginatedSearchDto;
class SelectOptionsDto {
}
exports.SelectOptionsDto = SelectOptionsDto;
class Base64EnabledDto {
}
exports.Base64EnabledDto = Base64EnabledDto;
//# sourceMappingURL=general.dto.js.map